import router from '@/router'
import * as TYPES from './types'
import { REGISTER_COMPLETION } from '@/store/modules/completion/types'

import { functions } from '@/services/firebase'

const SECTIONS_ORDER = ['introduction', 'eye', 'nose', 'aroma', 'mouth', 'conclusion']

export default {
  [TYPES.LOAD_TASTINGS] ({ commit }, { locale, callback = function(){} }) {
    const loadTastings = functions.httpsCallable('loadTastings')
    loadTastings({ locale }).then(response => {
      commit(TYPES.SET_TASTINGS, response.data)
      callback(null, true)
    })
  },
  [TYPES.NEXT_SECTION]({ getters, rootState }) {
    const tasting = getters.currentTasting
    const section = getters.currentSection
    const currentSectionId = rootState.route.params.sectionId

    // 1. No section - Go to the first section
    if (!section) {
      router.push({
        name: 'tasting-section',
        params: {
          tastingId: tasting.id,
          sectionId: SECTIONS_ORDER[0]
        }
      })

      return
    }

    const sectionIndex = SECTIONS_ORDER.findIndex(category => section.category === category)

    // 2. Last section - Go to the tasting summary
    if (sectionIndex === SECTIONS_ORDER.length - 1) {
      router.push({
        name: 'tasting-summary',
        params: { tastingId: tasting.id }
      })

      return
    }

    // 3. Go to the next section
    const nextSectionId = getNextSectionId(currentSectionId, tasting)

    // 3.1. No next section, end the tasting
    if (!nextSectionId) {
      router.push({ name: 'tasting-rating', params: { tastingId: tasting.id } })

      return
    }

    router.push({
      name: 'tasting-section',
      params: {
        tastingId: tasting.id,
        sectionId: nextSectionId
      }
    })
  },
  [TYPES.NEXT_TASTING_STEP]({ getters, rootState }) {
    const tasting = getters.currentTasting
    const section = getters.currentSection
    const sectionId = getSectionId(rootState)
    const step = getters.currentTastingStep

    if (section && section.length > 0) {
      // 1. No step - Take the first one
      console.log(step)
      if (!step) {
        const stepId = section[0].id
        console.log('stepid', stepId)

        return router.push({
          name: 'tasting-step',
          params: {
            stepId
          }
        })
      }

      const currentStepIndex = section.findIndex(sectionStep => step.id === sectionStep.id)

      // 2. Last steps - Section summary
      if (currentStepIndex === section.length - 1) {
        return router.push({
          name: 'section-summary',
          params: {
            tastingId: tasting.id,
            sectionId: sectionId
          }
        })
      }

      // 3. Next step
      const nextStep = section[currentStepIndex + 1]

      router.push({
        name: 'tasting-step',
        params: {
          tastingId: tasting.id,
          sectionId: sectionId,
          stepId: nextStep.id
        }
      })
    } else { // push to rating
      router.push({
        name: 'tasting-rating',
        params: {
          tastingId: tasting.id
        }
      })
    }
  },
  [TYPES.SUBMIT_TASTING_ANSWER]({ dispatch, commit, getters }, {questionId, answerId, value, correct }) {
    // Update the user response
    commit(TYPES.SET_TASTING_ANSWER, { answerId, value })
    // Create the document in firebase
    let letId = questionId
    if (letId == undefined) {
      id = getters.currentTastingQuestion.id
    }
    dispatch(REGISTER_COMPLETION, {
      contentType: 'tasting',
      id: letId,
      status: {
        answerId,
        value,
        correct
      }
    })

    // Dispatch an action to get the next step
    dispatch(TYPES.NEXT_TASTING_STEP)
  },
  [TYPES.RESTORE_PENDING_TASTING_FUNNEL]({ commit }, payload) {
    // Update the firebase funnel ID
    commit(TYPES.SET_TASTING_FIREBASE_ID, payload.id)
    // Rehydrate all previous answer from the user
    restoreTastingAnswers(commit, payload)
  },
  [TYPES.PREV_TASTING_STEP]({ getters, rootState }) {
    const tasting = getters.currentTasting
    const section = getters.currentSection
    const sectionId = getSectionId(rootState)
    const step = getters.currentTastingStep

    // 1. No step
    if (!step) {
      // Section summary, get back to the previous step
      if (router.currentRoute.name === 'section-summary') {
        return router.push({
          name: 'tasting-step',
          params: {
            tastingId: tasting.id,
            sectionId: sectionId,
            stepId: section[section.length - 1]
          }
        })
        // Tasting rating, get back to the previous summary
      } else if (router.currentRoute.name === 'tasting-rating') {
        const routerOptions = getLastSectionNavigation(tasting)

        return router.push(routerOptions)
      } else {
        return router.push({
          name: 'listTasting'
        })
      }
    }

    const currentStepIndex = section.findIndex(sectionStep => step.id === sectionStep.id)

    // 2. First step - Previous section
    if (currentStepIndex === 0) {
      const prevSection = getPrevSectionId(sectionId, tasting)

      // We are on the first section
      if (!prevSection) {
        return router.push({ name: 'listTasting' })
      } else {
        return router.push({
          // Introduction screen doesn't have a section summary
          name: prevSection === SECTIONS_ORDER[0] ? 'tasting-step' : 'section-summary',
          params: {
            tastingId: tasting.id,
            sectionId: prevSection,
            stepId: section[section.length - 1]
          }
        })
      }
    }

    // 3. Prev step
    const prevStep = section[currentStepIndex - 1]

    router.push({
      name: 'tasting-step',
      params: {
        tastingId: tasting.id,
        sectionId: sectionId,
        stepId: prevStep.id
      }
    })
  }
}

/**
 * Returns the section ID based on the navigation
 * @param {Store} rootState
 * @returns {string}
 */
function getSectionId(rootState) {
  return rootState.route.params.sectionId
}

/**
 * Retrieve the next section to display, falsy if the section is complete
 * @param {string} currentSectionId
 * @param {Tasting} tasting
 * @returns {string}
 */
function getNextSectionId(currentSectionId, tasting) {
  const currentSectionIndex = SECTIONS_ORDER.findIndex(section => section === currentSectionId)

  if (currentSectionIndex === SECTIONS_ORDER.length - 1) return undefined

  const nextSectionId = SECTIONS_ORDER[currentSectionIndex + 1]

  // Test if the next section is empty
  const nextSection = tasting[`${nextSectionId}Screens`]

  if (nextSection.length <= 0) {
    return getNextSectionId(nextSectionId, tasting)
  }

  return nextSectionId
}

/**
 * Retrieve the previous section to display, falsy if the section is complete
 * @param {string} currentSectionId
 * @param {Tasting} tasting
 * @returns {string | undefined}
 */
function getPrevSectionId(currentSectionId, tasting) {
  const currentSectionIndex = SECTIONS_ORDER.findIndex(section => section === currentSectionId)

  if (currentSectionIndex === 0) return undefined

  const prevSectionId = SECTIONS_ORDER[currentSectionIndex - 1]

  // Test if the previous section is empty
  const prevSection = tasting[`${prevSectionId}Screens`]

  if (prevSection.length <= 0) {
    return getPrevSectionId(prevSectionId, tasting)
  }

  return prevSectionId
}

/**
 * Restore the tasting answer of the user
 * @param {any} commit
 * @param {Object} payload
 */
function restoreTastingAnswers(commit, payload) {
  const tastingId = payload.tastingId

  // Don't go further if the user did not start any section
  if (!payload.sections) return

  // Retrieve all section IDs
  const sectionIds = Object.keys(payload.sections)
  // For each section, retrieve all the user answer
  sectionIds.forEach(sectionId => {
    const questions = payload.sections[sectionId]
    // For each question, set the response in the store
    Object.keys(questions).forEach(questionId => {
      const value = questions[questionId].value
      const answerId = `${tastingId}.${sectionId}.${questionId}`

      // restore the answer
      commit(TYPES.SET_TASTING_ANSWER, { answerId, value })
    })
  })
}

/**
 * @param {Tasting} tasting
 * @returns {{ name: string, params: Object }}
 */
function getLastSectionNavigation(tasting) {
  const { lastSection, lastSectionId } = SECTIONS_ORDER.filter(sectionId => {
    const sectionField = `${sectionId}Screens`

    return tasting[sectionField].length > 0
  })
    .map(sectionId => {
      const sectionField = `${sectionId}Screens`

      return {
        lastSectionId: sectionId,
        lastSection: tasting[sectionField]
      }
    })
    .pop()

  const containsQuestions = lastSection.some(step => step.schema === 'TastingQuestion')

  return {
    name: containsQuestions ? 'step-summary' : 'tasting-step',
    params: {
      tastingId: tasting.id,
      sectionId: lastSectionId,
      stepId: lastSection[lastSection.length - 1].id
    }
  }
}
